import { useEffect, useState, useCallback } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import { validateSerachSupplierForm } from '../../validation/Authentication/Validation';
import * as XLSX from 'xlsx';
import Navigations from '../../common/useNavigation.js';
const MidViewOrders = (type) => {

    const { navigateDashboard, navigateOrderDetails } = Navigations();
    const { users } = useGetUserData();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [seacrh, setSearch] = useState('');
    const [sheetdata, setSheetdata] = useState([]);
    const [orders, setOrders] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);
    useEffect(() => {
        //  console.log('called useeffectsss');
          if (Array.isArray(users) && users.length > 0) {
            //   console.log('useEffect called, users:', users);
              logUserData(); 
          }
      }, [users]); 
      
        const logUserData = () => {
          if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
    
            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && ( hasOne || (hasOne && hasTwo )) ) {
                
              }else
              {
          
                navigateDashboard('buyer');
              }
              

          }
        };
    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Product Category');
        XLSX.writeFile(wb, "Selzor_Orders_List.xlsx");
    }

    useEffect(() => {
        getBuyerOrders();
    }, []);
    const getBuyerOrders = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetBuyerOrder`, {app:0}, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        setOrders(res.data.data);
                        setFilteredCategories(res.data.data);
                        setSheetdata(res.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get suplliers, please try again later ", 'error');
        }
    }
    useEffect(() => {
        // console.log(seacrh);
        const filtered_result_by_order_id = orders.filter((order) => {
            return (
                (order.order_unique_key?.toLowerCase().match(seacrh?.toLowerCase())) ||
                (order.product_name?.toLowerCase().match(seacrh?.toLowerCase())) ||
                (order.full_name?.toLowerCase().match(seacrh?.toLowerCase()))
            );
        });
        setFilteredCategories(filtered_result_by_order_id);
    }, [seacrh]);
    
    return { users, seacrh, setSearch, exporttoExcelData, orders, filteredCategories, navigateOrderDetails, handleRowSelected }
}
export default MidViewOrders